// ── View Switcher — Network / Hierarchy / 3D toggle ──

export type ViewMode = "network" | "hierarchy" | "3d";

interface ViewSwitcherProps {
  active: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const views: Array<{ id: ViewMode; label: string; icon: string }> = [
  { id: "network", label: "Network", icon: "⬡" },
  { id: "hierarchy", label: "Hierarchy", icon: "⊞" },
  { id: "3d", label: "3D Globe", icon: "◉" },
];

export default function ViewSwitcher({ active, onChange }: ViewSwitcherProps) {
  return (
    <div className="flex items-center gap-1 bg-fl-forest/40 rounded-lg p-0.5">
      {views.map((v) => (
        <button
          key={v.id}
          onClick={() => onChange(v.id)}
          className={`flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium
            transition-all duration-200 ${
              active === v.id
                ? "bg-fl-leaf/30 text-white shadow-sm border border-fl-leaf/40"
                : "text-fl-sand-60 hover:text-white hover:bg-fl-forest/60 border border-transparent"
            }`}
        >
          <span className="text-sm">{v.icon}</span>
          {v.label}
        </button>
      ))}
    </div>
  );
}
